import { EEthereumNetworkId } from '@ankr.com/provider';
import config, { NetworkConfig } from 'config';

import { useChainData } from './useChainData';

export function useNetworkConfig(
  chainId?: EEthereumNetworkId,
): NetworkConfig | null {
  const chainData = useChainData();
  const selectedChainId = chainId ?? chainData?.chainId;
  if (!selectedChainId) {
    return null;
  }

  return config?.[selectedChainId] || null;
}
